import {authUserInfo} from "@/mixins/Auth.js"

function setViewResolver(component) {
    return require('../views/' + component).default;
}
export default [
    {
        path: '/',
        component: setViewResolver('member/Member'),
        name: 'DashBoard',
        meta: { title: '회원관리', sideName: '회원 관리', sideHidden: true, icon_name: 'member', authRequired: true},
        redirect: '/member'
    },{
        path: '/auth',
        component: setViewResolver('auth/Login'),
        meta: { title: '로그인', sideHidden: true, noHeader: true,},
        name: 'Auth',

    },{
        path: '/policy',
        component: setViewResolver('auth/Policy'),
        meta: { title: '개인정보취급방침', sideHidden: true, noHeader: true,},
        name: 'Auth',

    },{
        path: '/member',
        component: setViewResolver('RouteView'),
        meta: { title: '', sideName: '회원 관리', icon_name: 'member', authRequired: true},
        children: [
            {
                path: '',
                name: 'Member',
                component: setViewResolver('member/Member'),
                meta: {title: '회원 리스트', sideName: '회원 리스트', name: 'custom', icon_name: 'member'},
            },
            {
                path: 'out',
                name: 'MemberDeny',
                component: setViewResolver('member/DenyMember'),
                meta: {title: '탈퇴회원 리스트', sideName: '탈퇴회원 리스트', name: 'custom', icon_name: 'member'},
            },
            {
                path: ':mb_no',
                component: setViewResolver('member/MemberDetail'),
                name: 'MemberDetail',
                meta: {title: '회원 상세', sideName: '회원 상세',sideHidden: true},
            },
        ]
    },{
        path: '/order',
        component: setViewResolver('RouteView'),
        meta: {title: '', sideName: '결제/환불관리', icon_name: 'cart', name: 'order', authRequired: true},
        children: [
            {
                path: '',
                component: setViewResolver('order/Order'),
                name: 'Order',
                meta: {title: '모든 결제내역', sideName: '모든결제내역', name: 'Order'},
            },{
                path: 'refund',
                component: setViewResolver('order/Refund'),
                name: 'OrderRefund',
                meta: {title: '환불관리', sideName: '환불관리', name: 'OrderRefund'},
            },{
                path: 'refund/:wr_id',
                component: setViewResolver('order/RefundDetail'),
                name: 'OrderRefundDetail',
                meta: {title: '환불관리', sideName: '환불요청상세정보', sideHidden: true, name: 'OrderRefundDetail'},
            }
        ]
    },{
        path: '/service',
        component: setViewResolver('RouteView'),
        meta: {title: '', sideName: '고객센터관리', name: 'service', icon_name: 'cog', authRequired: true},
        children: [
            {
                path: 'notice',
                component: setViewResolver('notice/Notice'),
                name: 'ServiceNotice',
                meta: {title: '공지사항 리스트', sideName: '공지사항리스트'}
            },{
                path: 'notice/create',
                component: setViewResolver('notice/NoticeCreate'),
                name: 'ServiceNoticeCreate',
                meta: {title: '공지사항 작성', sideName: '', sideHidden: true,}
            },{
                path: 'notice/:wr_id',
                component: setViewResolver('notice/NoticeDetail'),
                name: 'ServiceNoticeUpdate',
                meta: {title: '공지사항 수정', sideName: '', sideHidden: true,}
            },
            {
                path: 'faq',
                component: setViewResolver('faq/Faq'),
                name: 'ServiceFaq',
                meta: {title: 'FAQ 리스트', sideName: 'FAQ리스트'}
            },{
                path: 'faq/create',
                component: setViewResolver('faq/FaqCreate'),
                name: 'ServiceFaqCreate',
                meta: {title: 'FAQ 작성', sideName: '', sideHidden: true,}
            },{
                path: 'faq/:fa_idx',
                component: setViewResolver('faq/FaqDetail'),
                name: 'ServiceFaqUpdate',
                meta: {title: 'FAQ 작성', sideName: '', sideHidden: true,}
            },{
                path: 'qa',
                component: setViewResolver('qa/Qa'),
                name: 'OrderRefund',
                meta: {title: '1:1문의관리', sideName: '1:1문의리스트', name: 'OrderRefund', sideHidden: false},
            },{
                path: 'qa/:qq_idx',
                component: setViewResolver('qa/QaDetail'),
                name: 'OrderRefundDetail',
                meta: {title: '1:1문의관리', sideName: '1:1문의상세정보', sideHidden: true, name: 'OrderRefundDetail'},
            }
        ]
    },{
        path: '/config',
        component: setViewResolver('RouteView'),
        name: 'Config',
        meta: {title: '', sideName: '약관관리', name: 'config', icon_name: 'board', authRequired: true},
        children: [
            {
                path: 'service',
                component: setViewResolver('config/service/Service'),
                name: 'Service',
                meta: {title: '서비스 이용약관', sideName: '서비스 이용약관'}
            },{
                path: 'service/create',
                component: setViewResolver('config/service/ServiceCreate'),
                name: 'ServiceCreate',
                meta: {title: '서비스 이용약관 작성', sideName: '', sideHidden: true,}
            },{
                path: 'service/:id',
                component: setViewResolver('config/service/ServiceDetail'),
                name: 'ServiceUpdate',
                meta: {title: '서비스 이용약관 수정', sideName: '', sideHidden: true,}
            },

            {
                path: 'policy',
                component: setViewResolver('config/policy/Policy'),
                name: 'Service',
                meta: {title: '개인정보처리방침', sideName: '개인정보처리방침'}
            },{
                path: 'policy/create',
                component: setViewResolver('config/policy/PolicyCreate'),
                name: 'PolicyCreate',
                meta: {title: '개인정보처리방침 작성', sideName: '', sideHidden: true,}
            },{
                path: 'policy/:id',
                component: setViewResolver('config/policy/PolicyDetail'),
                name: 'PolicyUpdate',
                meta: {title: '개인정보처리방침 수정', sideName: '', sideHidden: true,}
            },

            {
                path: 'leave',
                component: setViewResolver('config/leave/Leave'),
                name: 'Leave',
                meta: {title: '회원탈퇴약관', sideName: '회원탈퇴약관'}
            },{
                path: 'leave/create',
                component: setViewResolver('config/leave/LeaveCreate'),
                name: 'LeaveCreate',
                meta: {title: '회원탈퇴약관 작성', sideName: '', sideHidden: true,}
            },{
                path: 'leave/:id',
                component: setViewResolver('config/leave/LeaveDetail'),
                name: 'LeaveUpdate',
                meta: {title: '회원탈퇴약관 수정', sideName: '', sideHidden: true,}
            },

            {
                path: 'credit',
                component: setViewResolver('config/credit/Credit'),
                name: 'Credit',
                meta: {title: '결제약관', sideName: '결제약관'}
            },{
                path: 'credit/create',
                component: setViewResolver('config/credit/CreditCreate'),
                name: 'CreditCreate',
                meta: {title: '결제약관 작성', sideName: '', sideHidden: true,}
            },{
                path: 'credit/:id',
                component: setViewResolver('config/credit/CreditDetail'),
                name: 'CreditUpdate',
                meta: {title: '결제약관 수정', sideName: '', sideHidden: true,}
            },

            {
                path: 'refund',
                component: setViewResolver('config/refund/Refund'),
                name: 'Refund',
                meta: {title: '환불약관', sideName: '환불약관'}
            },{
                path: 'refund/create',
                component: setViewResolver('config/refund/RefundCreate'),
                name: 'RefundCreate',
                meta: {title: '환불약관 작성', sideName: '', sideHidden: true,}
            },{
                path: 'refund/:id',
                component: setViewResolver('config/refund/RefundDetail'),
                name: 'RefundUpdate',
                meta: {title: '환불약관 수정', sideName: '', sideHidden: true,}
            },
        ]
    },{
        path: '/popup',
        component: setViewResolver('popup/Popup'),
        meta: {title: '팝업 리스트', sideName: '팝업 리스트', icon_name: 'briefcase', name: 'popup', authRequired: true},
    },{
        path: '/popup/create',
        component: setViewResolver('popup/PopupCreate'),
        meta: {title: '팝업 등록', sideName: '팝업 등록',  sideHidden: true, name: 'popup', authRequired: true},
    },{
        path: '/popup/:e_idx',
        component: setViewResolver('popup/PopupDetail'),
        meta: {title: '팝업 상세', sideName: '팝업 상세', sideHidden: true, name: 'popup', authRequired: true},
    }

]
